import { Link } from 'react-router-dom';
import { FiMail, FiInstagram, FiFacebook } from 'react-icons/fi';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-dark text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-white rounded-md p-2">
                <img src="/logo.png" alt="TeachESLPro" className="h-10 w-auto" />
              </div>
              <span className="text-xl font-heading font-bold text-primary bg-white px-2 py-1">
                Teach<span className="text-primary-teal">ESL</span>Pro
              </span>
            </div>
            <p className="text-gray-300 font-body mb-4 md:text-balance md:max-w-sm">
              A complete teaching platform for private and freelance ESL tutors.
              Placement, pathways and hand-made resources - all in one place.
            </p>
            <div className="flex space-x-4">
              <a href="mailto:info@teacheslpro.com" className="text-gray-300 hover:text-white transition-colors">
                <FiMail className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <FiInstagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <FiFacebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-subheading font-semibold mb-4 !text-white">Quick links</h4>
            <ul className="space-y-2 font-body">
              <li>
                <a href="/#pricing" className="text-gray-300 hover:text-white transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <Link to="/resources" className="text-gray-300 hover:text-white transition-colors">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/demo" className="text-gray-300 hover:text-white transition-colors">
                  Watch the demo
                </Link>
              </li>
              <li>
                <Link to="/free-placement-test" className="text-gray-300 hover:text-white transition-colors">
                  Free placement test
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-subheading font-semibold mb-4 !text-white">Legal</h4>
            <ul className="space-y-2 font-body">
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">
                  Privacy policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">
                  Terms of service
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-gray-300 hover:text-white transition-colors">
                  Refund policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 font-body">
            <span className="bg-white px-2 py-1 inline-block">
              © {currentYear} <span className="text-primary">Teach<span className="text-primary-teal">ESL</span>Pro</span>. All rights reserved.
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
